export default __webpack_public_path__ + "static/media/Pil Andina-09.75024658.png";